import { useContext } from "react";
import context from "./context";

const useAuth = () => {
    return useContext(context);
};

export default useAuth;